import React from 'react';
import messages from '../../text/messages';
import { FormattedMessage } from 'react-intl';
import Card from '../card';
import './card.css';

export function emptyPageCard(pageTitleMessage, message, cardTitleMessage = messages.emptyMessage) {
    const pageTitle = <FormattedMessage {...pageTitleMessage} />;
    const cardTitle = <FormattedMessage {...cardTitleMessage} />;
    const cardContent = (
        <div className="row">
            <div className="col-xs-12">
                <FormattedMessage {...message} />
            </div>
        </div>
    );
    return (
        <div>
            <div className="tabs-title">
                <h4>{pageTitle}</h4>
            </div>
            <Card title={cardTitle} content={cardContent} />
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/components/emptyPageCard/index.jsx